import {
  Box,
  Flex,
  HStack,
  Icon,
  MenuItem,
  MenuList,
  Spinner,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { FiSearch } from 'react-icons/fi';
import { Link, useHistory } from 'react-router-dom';
import { BsFillInfoCircleFill } from 'react-icons/all';
import {
  Heading,
  Input,
  Menu,
  Pagination,
  StatusBadge,
  Table,
} from '~/components';
import { ROUTER_PATHS } from '~/constants';
import { useDebounce } from '~/hooks/useDebounce';
import { useEquipments } from '~/hooks/useEquipments';
import { replaceParameters } from '~/utils/replaceParamaters';

export const Equipments: React.VFC = () => {
  const history = useHistory();
  const savedPage = sessionStorage.getItem('page');
  const savedSearch = sessionStorage.getItem('search');
  const [page, setPage] = useState(Number(savedPage) || 1);
  const [search, setSearch] = useState(savedSearch || '');
  const [searchTmp, setSearchTmp] = useState(savedSearch || '');

  const { data, isLoading, isError, isFetching, refetch } = useEquipments(
    Number(savedPage),
    savedSearch || '',
    100,
  );

  useEffect(() => {
    sessionStorage.setItem('page', String(page));
    sessionStorage.setItem('search', search);
    refetch();
  }, [page, search]);

  function handleNavigate(id: number) {
    history.push(
      `${replaceParameters(
        ROUTER_PATHS.PORTAL.ADMIN.EQUIPMENTS_FORM_EDIT,
        String(id),
      )}`,
    );
  }

  useDebounce(
    async () => {
      setPage(1);
      setSearch(searchTmp);
      refetch();
    },
    1000,
    [searchTmp],
  );

  useEffect(() => {
    refetch();
  }, []);

  return (
    <Box px="8" py="4">
      <Heading hasBackButton>Equipamentos</Heading>
      <Flex pt={2} flexDir="column" w="100%">
        <Flex justify="space-between" py={9}>
          <Flex align="center" gridGap={4}>
            <Input
              name="search"
              type="text"
              icon={FiSearch}
              value={searchTmp}
              onChange={e => setSearchTmp(e.target.value)}
              placeholder="Procure por código, modelo ou tipo"
              w={350}
              fontSize="15px"
            />
            {isFetching && <Spinner />}
          </Flex>
        </Flex>
        {isLoading ? (
          <Flex justify="center">
            <Spinner />
          </Flex>
        ) : isError ? (
          <Flex justify="center">
            <Text>Falha ao obter dados dos equipamentos.</Text>
          </Flex>
        ) : (
          <>
            <Table>
              <Thead>
                <Tr>
                  <Th>SKU</Th>
                  <Th>Tipo</Th>
                  <Th>Modelo</Th>
                  <Th>Descrição</Th>
                  <Th>Status</Th>
                  <Th />
                </Tr>
              </Thead>
              <Tbody>
                {data &&
                  data.results.map(equipment => (
                    <Tr key={`${equipment.id_equipamento}`}>
                      <Td>
                        <Link
                          to={`${replaceParameters(
                            ROUTER_PATHS.PORTAL.ADMIN.EQUIPMENTS_FORM_EDIT,
                            String(equipment.id_equipamento),
                          )}`}
                        >
                          <Text
                            _hover={{
                              color: 'gray.900',
                              textDecoration: 'underline',
                            }}
                          >
                            {equipment.cd_equipamento}
                          </Text>
                        </Link>
                      </Td>
                      <Td>
                        {equipment?.tipo_equipamento?.nm_tipoequipamento || '-'}
                      </Td>
                      <Td>
                        {equipment?.modelo_equipamento?.nm_modeloequipamento ||
                          '-'}
                      </Td>
                      <Td
                        color={
                          equipment.descricao_alterada_manualmente
                            ? '#0082B8'
                            : 'black'
                        }
                        fontWeight={
                          equipment.descricao_alterada_manualmente ? 600 : 400
                        }
                      >
                        <HStack justifyContent="space-between">
                          <span>{equipment?.ds_equipamento || '-'}</span>
                          {equipment.descricao_alterada_manualmente && (
                            <Tooltip
                              hasArrow
                              label="Essa descrição foi alterada."
                              bg="gray"
                              shouldWrapChildren
                            >
                              <Icon
                                color="black"
                                marginLeft="auto"
                                as={BsFillInfoCircleFill}
                              />
                            </Tooltip>
                          )}
                        </HStack>
                      </Td>
                      <Td>
                        <StatusBadge variant={equipment.colorScheme}>
                          {equipment.formattedStatus}
                        </StatusBadge>
                      </Td>
                      <Td>
                        <Menu>
                          <MenuList>
                            <MenuItem
                              onClick={() =>
                                handleNavigate(equipment.id_equipamento)
                              }
                            >
                              Editar
                            </MenuItem>
                          </MenuList>
                        </Menu>
                      </Td>
                    </Tr>
                  ))}
              </Tbody>
            </Table>
            <Flex justify="flex-end">
              {data && (
                <Pagination
                  totalCountOfRegisters={data.count}
                  registersPerPage={100}
                  currentPage={page}
                  onPageChange={setPage}
                />
              )}
            </Flex>
          </>
        )}
      </Flex>
    </Box>
  );
};
